import React from "react";
import "./relatedarticle.scss";
import Slider from "react-slick";
import { LazyLoadImage } from "react-lazy-load-image-component";
//import "react-lazy-load-image-component/src/effects/blur.css";
import ImageConvertionDefault from "../../config";
export default class RelatedArticle extends React.PureComponent {
  render() {
    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      arrows: true,

      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            initialSlide: 3,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2,
          },
        },
      ],
    };
    let pagelist = this.props.dataFromParent;
    //console.log("related" + pagelist);
    const _PagelistDataItemss = pagelist.map((item, count) => (
      <div className="related_arti_panel" key={count}>
        <div className="r_a_p_head">
          <h2>
            <label>{item.Title}</label>
          </h2>
        </div>
        <div className="r_a_p_body">
          <div className="related_news_slider">
            <Slider {...settings}>
              {item.Pages.map((item, i) => (
                <div>
                  <div className="related_news_block" key={i}>
                    <a href={item.Url}>
                      <LazyLoadImage
                        effect="blur"
                        src={ImageConvertionDefault(
                          item.Image || item.Thumbnail, 370, 295
                        )}
                        alt={item.Title}
                        width="100%"
                        height="auto"
                      />
                    </a>
                    <label>{item.CategoryName || "Webdunia"}</label>
                    <h2>
                      <a href={item.Url}>
                        {item.Description.slice(0, 85) + "..."}
                      </a>
                    </h2>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    ));
    return <>{_PagelistDataItemss}</>;
  }
}
